import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const CreateEditEventModal = ({
  open,
  handleClose,
  handleSubmit,
  eventData,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    start: dayjs(),
    end: dayjs(),
    description: "",
    id: null,
  });

  const initialFormData = useMemo(
    () => ({
      name: "",
      startDate: dayjs(),
      endDate: dayjs(),
      description: "",
      id: null,
    }),
    []
  );

  useEffect(() => {
    if (eventData) {
      setFormData({
        name: eventData.name || "",
        start: dayjs(eventData.start) || dayjs(),
        end: dayjs(eventData.end) || dayjs(),
        description: eventData.description || "",
        id: eventData.id || null,
      });
    } else {
      setFormData(initialFormData);
    }
  }, [eventData, initialFormData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleStartDateChange = (newValue) => {
    setFormData((prevState) => ({
      ...prevState,
      start: newValue,
    }));
  };

  const handleEndDateChange = (newValue) => {
    setFormData((prevState) => ({
      ...prevState,
      end: newValue,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <form onSubmit={onSubmit}>
            <Typography variant="h3">
              {eventData ? "Edit Event" : "Create Event"}
            </Typography>
            <div>
              <TextField
                id="name"
                label="Name"
                name="name"
                variant="outlined"
                type="name"
                fullWidth
                value={formData.name}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div>
              <TextField
                id="description"
                label="Description"
                name="description"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                value={formData.description}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div>
              <DateTimePicker
                label="Start Date & Time"
                value={formData.start || dayjs()}
                onChange={handleStartDateChange}
                inputFormat="DD.MM.YYYY HH:mm:ss"
                slotProps={{
                  textField: { variant: "outlined", fullWidth: true },
                }}
              />
            </div>
            <div>
              <DateTimePicker
                label="End Date & Time"
                value={formData.end || dayjs()}
                onChange={handleEndDateChange}
                inputFormat="DD.MM.YYYY HH:mm:ss"
                slotProps={{
                  textField: { variant: "outlined", fullWidth: true },
                }}
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" onClick={onSubmit}>
            {eventData ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default CreateEditEventModal;
